import React, { useState, useEffect, useRef } from "react";
import { Button, TextField, Typography, Stack, Paper, Grid, Container, Box, Divider, Autocomplete, FormControlLabel, Skeleton, Snackbar, Checkbox } from '@mui/material';
import Page from "../components/Page";
import { useGetLanguagesQuery } from "../rtk/language";
import MuiPhoneNumber from "mui-phone-number";
import { useGetDossiersQuery } from "../rtk/dossiers";
import { useCreateCandidateMutation } from "../rtk/candidates";
import { useNavigate } from "react-router-dom";
import PasswordTextField from "../components/PasswordTextField";

const CandidateAdd = (props) => {
    const navigate = useNavigate()
    const { data: languages, isLoading: languagesLoading } = useGetLanguagesQuery();
    const { data: dossiers, isLoading: dossiersLoading } = useGetDossiersQuery();

    const [createCandidate, response] = useCreateCandidateMutation();

    useEffect(() => {
        if (response.data) {
            navigate(`/candidates/${response.data.pk}`)
        }
    }, [response.data])

    const [candidate, setCandidate] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        username: "",
        password: "",
        password2: "",
        is_active: true,
        language: 1,
        with_email: true,
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        createCandidate(candidate);
    }


    const normalizeStr = (str) => {
        return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s/g, "")
    }

    const candidateOnChange = (e) => {

        if (e.target.name == "last_name" || e.target.name == "first_name") {
            const oldUsername = normalizeStr(candidate.first_name + "." + candidate.last_name)
            let newUsername = (e.target.name === "first_name" ? normalizeStr(e.target.value) : normalizeStr(candidate.first_name)) + "." + (e.target.name === "last_name" ? normalizeStr(e.target.value) : normalizeStr(candidate.last_name))
            if (candidate.username === oldUsername || candidate.username === "") {
                setCandidate({ ...candidate, [e.target.name]: e.target.value, "username": newUsername })
                return
            }
        }

        setCandidate({ ...candidate, [e.target.name]: e.target.value })

    }

    const generatePassword = () => {
        const length = 6;
        const voyels = "aeiouyAEIOUY";
        const consonants = "bcdfghjklmnpqrstvwxzBCDFGHJKLMNPQRSTVWXZ";
        // const special = "!@#$%^&*()_+~`|}{[]:;?><,./-="
        let retVal = "";
        // alternate between consonants and voyels
        for (let i = 0; i < length; i++) {
            if (i % 2 === 0) {
                retVal += consonants.charAt(Math.floor(Math.random() * consonants.length));
            } else {
                retVal += voyels.charAt(Math.floor(Math.random() * voyels.length));
            }
        }
        //add a number
        retVal += Math.floor(Math.random() * 10);
        retVal += Math.floor(Math.random() * 10);
        retVal += Math.floor(Math.random() * 10);

        //add a special character
        // retVal += special.charAt(Math.floor(Math.random() * special.length))

        setCandidate({ ...candidate, "password": retVal, "password2": retVal })
    }

    const getUserReadableError = (error) => {
        if (!error) {
            return ""
        }
        if (error.includes("username")) {
            return "Le nom d'utilisateur est déjà utilisé"
        }
        if (error.includes("email")) {
            return "Le courriel est déjà utilisé"
        }
        return error
    }

    return (
        <Page title={"Nouveau candidat"} needGoBack>
            <Box component={"form"} onSubmit={handleSubmit}>
                <Paper sx={{ p: 2 }} elevation={9}>
                    <Typography variant="h5" sx={{ mb: 2 }}>Informations personnelles</Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                required
                                id="first_name"
                                name="first_name"
                                label="Prénom"
                                fullWidth
                                value={candidate.first_name}
                                onChange={candidateOnChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                required
                                id="last_name"
                                name="last_name"
                                label="Nom"
                                fullWidth
                                value={candidate.last_name}
                                onChange={candidateOnChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                required
                                id="email"
                                name="email"
                                label="Courriel"
                                fullWidth
                                value={candidate.email}
                                onChange={candidateOnChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {
                                languagesLoading ? "Chargement..." :

                                    <Autocomplete
                                        id="language"
                                        name="language"
                                        options={languages}
                                        value={languages.find((language) => language.id === candidate.language)}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField {...params} label="Langue" />}
                                        onChange={(e, value) => setCandidate({ ...candidate, language: value.id })}
                                    />
                            }
                        </Grid>
                    </Grid>
                </Paper>
                <Paper sx={{ p: 2, mt: 2 }} elevation={9}>
                    <Typography variant="h5" sx={{ mb: 2 }}>Informations de dossier</Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            {
                                dossiersLoading ? <Skeleton /> :

                                    <Autocomplete
                                        id="dossier"
                                        name="dossier"
                                        options={dossiers}
                                        value={dossiers.find((dossier) => dossier.id === candidate.dossier)}
                                        getOptionLabel={(option) => option.name}
                                        renderInput={(params) => <TextField {...params} label="Dossier" />}
                                        onChange={(e, value) => setCandidate({ ...candidate, dossier: value.id })}
                                    />
                            }
                        </Grid>
                    </Grid>
                </Paper>
                <Paper sx={{ p: 2, mt: 2 }} elevation={9}>
                    <Typography variant="h5" sx={{ mb: 2 }}>Informations de connexion</Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={3}>
                            <TextField
                                required
                                id="username"
                                name="username"
                                label="Nom d'utilisateur"
                                fullWidth
                                value={candidate.username}
                                onChange={(e) => setCandidate({ ...candidate, username: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <PasswordTextField
                                required
                                id="password"
                                name="password"
                                label="Mot de passe"
                                fullWidth
                                value={candidate.password}
                                onChange={(e) => setCandidate({ ...candidate, password: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <PasswordTextField
                                required
                                id="password2"
                                name="password2"
                                label="Confirmer le mot de passe"
                                fullWidth
                                value={candidate.password2}
                                onChange={(e) => setCandidate({ ...candidate, password2: e.target.value })}
                            />
                        </Grid>
                        <Grid item xs={12} md={1} container justifyContent={"center"}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={generatePassword}
                            >
                                Générer
                            </Button>
                        </Grid>
                    </Grid>
                    <FormControlLabel
                        control={<Checkbox checked={candidate.with_email} onChange={(e) => setCandidate({...candidate, with_email:e.target.checked})} />
                        }
                        label="Envoyer un courriel avec les informations de connexion?"
                    />
                </Paper>
                <Box sx={{ mt: 2, display: "flex" }} justifyContent={"flex-end"}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => console.log(candidate)}
                        type="submit"
                    >
                        Ajouter
                    </Button>
                </Box>
            </Box>
            <Snackbar open={response.error} autoHideDuration={6000} message={getUserReadableError(JSON.stringify(response.error?.data))} />
        </Page>
    )
}
export default CandidateAdd